import React, { useContext } from 'react'

export const useOptionsContext = () => useContext(OptionsContext)

const defaultValues = { color: 'red' }
const OptionsContext = React.createContext(defaultValues)

export default OptionsContext
